<template>
    <modal id="attribute-modal"
        size="large"
        v-model="showModal"
        :title="generateModalTitle('attribute')"
        @submit="submitData" :loading="loading"
        :preloader="preloader">

        <form
            ref="form"
            :data-url='selectedUrl ? selectedUrl : `${TENANT_BASE_URL}app/attribute`'
            @submit.prevent="submitData"
        >
            <app-form-group
                page="page"
                :label="$t('active')"
                type="switch"
                v-model="formData.is_active"
                :error-message="$errorMessage(errors, 'is_active')"
            />
            <app-form-group
                page="page"
                :label="$t('language')"
                type="select"
                v-model="locate"
                :list="languages"
            />
            <app-form-group
                page="page"
                :label="$t('name')"
                type="text"
                v-model="formData.name"
                :placeholder="$placeholder('name', '')"
                :error-message="$errorMessage(errors, 'name')"
                :required="true"
            />
            <app-form-group
                page="page"
                :label="$t('label')"
                type="text"
                :placeholder="$placeholder('label', '')"
                v-model="formData.label[locate]"
                :error-message="$errorMessage(errors, 'label')"
                :required="true"
            />
            <app-form-group
                page="page"
                :label="$t('order')"
                type="number"
                v-model="formData.order"
                :error-message="$errorMessage(errors, 'order')"
            />
            <app-form-group
                page="page"
                type="search-select"
                v-model="formData.icon"
                list-value-field="name"
                :icon="true"
                :required="true"
                :label="$t('icon')"
                :list="[
                    { id: 'activity', name: '<i data-feather=\'activity\'>Activity</i>' },
                    { id: 'airplay', name: '<i data-feather=\'airplay\'>Airplay</i>' },
                    { id: 'alert-circle', name: '<i data-feather=\'alert-circle\'>Alert circle</i>' },
                    { id: 'alert-octagon', name: '<i data-feather=\'alert-octagon\'>Alert octagon</i>' },
                    { id: 'alert-triangle', name: '<i data-feather=\'alert-triangle\'>Alert triangle</i>' },
                    { id: 'align-center', name: '<i data-feather=\'align-center\'>Align center</i>' },
                    { id: 'align-justify', name: '<i data-feather=\'align-justify\'>Align justify</i>' },
                    { id: 'align-left', name: '<i data-feather=\'align-left\'>Align left</i>' },
                    { id: 'align-right', name: '<i data-feather=\'align-right\'>Align right</i>' },
                    { id: 'anchor', name: '<i data-feather=\'anchor\'>Anchor</i>' },
                    { id: 'aperture', name: '<i data-feather=\'aperture\'>Aperture</i>' },
                    { id: 'archive', name: '<i data-feather=\'archive\'>Archive</i>' },
                    { id: 'arrow-down-circle', name: '<i data-feather=\'arrow-down-circle\'>Arrow down circle</i>' },
                    { id: 'arrow-down-left', name: '<i data-feather=\'arrow-down-left\'>Arrow down left</i>' },
                    { id: 'arrow-down-right', name: '<i data-feather=\'arrow-down-right\'>Arrow down right</i>' },
                    { id: 'arrow-down', name: '<i data-feather=\'arrow-down\'>Arrow down</i>' },
                    { id: 'arrow-left-circle', name: '<i data-feather=\'arrow-left-circle\'>Arrow left circle</i>' },
                    { id: 'arrow-left', name: '<i data-feather=\'arrow-left\'>Arrow left</i>' },
                    { id: 'arrow-right-circle', name: '<i data-feather=\'arrow-right-circle\'>Arrow right circle</i>' },
                    { id: 'arrow-right', name: '<i data-feather=\'arrow-right\'>Arrow right</i>' },
                    { id: 'arrow-up-circle', name: '<i data-feather=\'arrow-up-circle\'>Arrow up circle</i>' },
                    { id: 'arrow-up-left', name: '<i data-feather=\'arrow-up-left\'>Arrow up left</i>' },
                    { id: 'arrow-up-right', name: '<i data-feather=\'arrow-up-right\'>Arrow up right</i>' },
                    { id: 'arrow-up', name: '<i data-feather=\'arrow-up\'>Arrow up</i>' },
                    { id: 'at-sign', name: '<i data-feather=\'at-sign\'>At sign</i>' },
                    { id: 'award', name: '<i data-feather=\'award\'>Award</i>' },
                    { id: 'bar-chart-2', name: '<i data-feather=\'bar-chart-2\'>Bar chart 2</i>' },
                    { id: 'bar-chart', name: '<i data-feather=\'bar-chart\'>Bar chart</i>' },
                    { id: 'battery-charging', name: '<i data-feather=\'battery-charging\'>Battery charging</i>' },
                    { id: 'battery', name: '<i data-feather=\'battery\'>Battery</i>' },
                    { id: 'bell-off', name: '<i data-feather=\'bell-off\'>Bell off</i>' },
                    { id: 'bell', name: '<i data-feather=\'bell\'>Bell</i>' },
                    { id: 'bluetooth', name: '<i data-feather=\'bluetooth\'>Bluetooth</i>' },
                    { id: 'bold', name: '<i data-feather=\'bold\'>Bold</i>' },
                    { id: 'book-open', name: '<i data-feather=\'book-open\'>Book open</i>' },
                    { id: 'book', name: '<i data-feather=\'book\'>Book</i>' },
                    { id: 'bookmark', name: '<i data-feather=\'bookmark\'>Bookmark</i>' },
                    { id: 'box', name: '<i data-feather=\'box\'>Box</i>' },
                    { id: 'briefcase', name: '<i data-feather=\'briefcase\'>Briefcase</i>' },
                    { id: 'calendar', name: '<i data-feather=\'calendar\'>Calendar</i>' },
                    { id: 'camera-off', name: '<i data-feather=\'camera-off\'>Camera off</i>' },
                    { id: 'camera', name: '<i data-feather=\'camera\'>Camera</i>' },
                    { id: 'cast', name: '<i data-feather=\'cast\'>Cast</i>' },
                    { id: 'check-circle', name: '<i data-feather=\'check-circle\'>Check circle</i>' },
                    { id: 'check-square', name: '<i data-feather=\'check-square\'>Check square</i>' },
                    { id: 'check', name: '<i data-feather=\'check\'>Check</i>' },
                    { id: 'chevron-down', name: '<i data-feather=\'chevron-down\'>Chevron down</i>' },
                    { id: 'chevron-left', name: '<i data-feather=\'chevron-left\'>Chevron left</i>' },
                    { id: 'chevron-right', name: '<i data-feather=\'chevron-right\'>Chevron right</i>' },
                    { id: 'chevron-up', name: '<i data-feather=\'chevron-up\'>Chevron up</i>' },
                    { id: 'chevrons-down', name: '<i data-feather=\'chevrons-down\'>Chevrons down</i>' },
                    { id: 'chevrons-left', name: '<i data-feather=\'chevrons-left\'>Chevrons left</i>' },
                    { id: 'chevrons-right', name: '<i data-feather=\'chevrons-right\'>Chevrons right</i>' },
                    { id: 'chevrons-up', name: '<i data-feather=\'chevrons-up\'>Chevrons up</i>' },
                    { id: 'chrome', name: '<i data-feather=\'chrome\'>Chrome</i>' },
                    { id: 'circle', name: '<i data-feather=\'circle\'>Circle</i>' },
                    { id: 'clipboard', name: '<i data-feather=\'clipboard\'>Clipboard</i>' },
                    { id: 'clock', name: '<i data-feather=\'clock\'>Clock</i>' },
                    { id: 'cloud-drizzle', name: '<i data-feather=\'cloud-drizzle\'>Cloud drizzle</i>' },
                    { id: 'cloud-lightning', name: '<i data-feather=\'cloud-lightning\'>Cloud lightning</i>' },
                    { id: 'cloud-off', name: '<i data-feather=\'cloud-off\'>Cloud off</i>' },
                    { id: 'cloud-rain', name: '<i data-feather=\'cloud-rain\'>Cloud rain</i>' },
                    { id: 'cloud-snow', name: '<i data-feather=\'cloud-snow\'>Cloud snow</i>' },
                    { id: 'cloud', name: '<i data-feather=\'cloud\'>Cloud</i>' },
                    { id: 'code', name: '<i data-feather=\'code\'>Code</i>' },
                    { id: 'codepen', name: '<i data-feather=\'codepen\'>Codepen</i>' },
                    { id: 'codesandbox', name: '<i data-feather=\'codesandbox\'>Codesandbox</i>' },
                    { id: 'coffee', name: '<i data-feather=\'coffee\'>Coffee</i>' },
                    { id: 'columns', name: '<i data-feather=\'columns\'>Columns</i>' },
                    { id: 'command', name: '<i data-feather=\'command\'>Command</i>' },
                    { id: 'compass', name: '<i data-feather=\'compass\'>Compass</i>' },
                    { id: 'copy', name: '<i data-feather=\'copy\'>Copy</i>' },
                    { id: 'corner-down-left', name: '<i data-feather=\'corner-down-left\'>Corner down left</i>' },
                    { id: 'corner-down-right', name: '<i data-feather=\'corner-down-right\'>Corner down right</i>' },
                    { id: 'corner-left-down', name: '<i data-feather=\'corner-left-down\'>Corner left down</i>' },
                    { id: 'corner-left-up', name: '<i data-feather=\'corner-left-up\'>Corner left up</i>' },
                    { id: 'corner-right-down', name: '<i data-feather=\'corner-right-down\'>Corner right down</i>' },
                    { id: 'corner-right-up', name: '<i data-feather=\'corner-right-up\'>Corner right up</i>' },
                    { id: 'corner-up-left', name: '<i data-feather=\'corner-up-left\'>Corner up left</i>' },
                    { id: 'corner-up-right', name: '<i data-feather=\'corner-up-right\'>Corner up right</i>' },
                    { id: 'cpu', name: '<i data-feather=\'cpu\'>Cpu</i>' },
                    { id: 'credit-card', name: '<i data-feather=\'credit-card\'>Credit card</i>' },
                    { id: 'crop', name: '<i data-feather=\'crop\'>Crop</i>' },
                    { id: 'crosshair', name: '<i data-feather=\'crosshair\'>Crosshair</i>' },
                    { id: 'database', name: '<i data-feather=\'database\'>Database</i>' },
                    { id: 'delete', name: '<i data-feather=\'delete\'>Delete</i>' },
                    { id: 'disc', name: '<i data-feather=\'disc\'>Disc</i>' },
                    { id: 'divide-circle', name: '<i data-feather=\'divide-circle\'>Divide circle</i>' },
                    { id: 'divide-square', name: '<i data-feather=\'divide-square\'>Divide square</i>' },
                    { id: 'divide', name: '<i data-feather=\'divide\'>Divide</i>' },
                    { id: 'dollar-sign', name: '<i data-feather=\'dollar-sign\'>Dollar sign</i>' },
                    { id: 'download-cloud', name: '<i data-feather=\'download-cloud\'>Download cloud</i>' },
                    { id: 'download', name: '<i data-feather=\'download\'>Download</i>' },
                    { id: 'dribbble', name: '<i data-feather=\'dribbble\'>Dribbble</i>' },
                    { id: 'droplet', name: '<i data-feather=\'droplet\'>Droplet</i>' },
                    { id: 'edit-2', name: '<i data-feather=\'edit-2\'>Edit 2</i>' },
                    { id: 'edit-3', name: '<i data-feather=\'edit-3\'>Edit 3</i>' },
                    { id: 'edit', name: '<i data-feather=\'edit\'>Edit</i>' },
                    { id: 'external-link', name: '<i data-feather=\'external-link\'>External link</i>' },
                    { id: 'eye-off', name: '<i data-feather=\'eye-off\'>Eye off</i>' },
                    { id: 'eye', name: '<i data-feather=\'eye\'>Eye</i>' },
                    { id: 'facebook', name: '<i data-feather=\'facebook\'>Facebook</i>' },
                    { id: 'fast-forward', name: '<i data-feather=\'fast-forward\'>Fast forward</i>' },
                    { id: 'feather', name: '<i data-feather=\'feather\'>Feather</i>' },
                    { id: 'figma', name: '<i data-feather=\'figma\'>Figma</i>' },
                    { id: 'file-minus', name: '<i data-feather=\'file-minus\'>File minus</i>' },
                    { id: 'file-plus', name: '<i data-feather=\'file-plus\'>File plus</i>' },
                    { id: 'file-text', name: '<i data-feather=\'file-text\'>File text</i>' },
                    { id: 'file', name: '<i data-feather=\'file\'>File</i>' },
                    { id: 'film', name: '<i data-feather=\'film\'>Film</i>' },
                    { id: 'filter', name: '<i data-feather=\'filter\'>Filter</i>' },
                    { id: 'flag', name: '<i data-feather=\'flag\'>Flag</i>' },
                    { id: 'folder-minus', name: '<i data-feather=\'folder-minus\'>Folder minus</i>' },
                    { id: 'folder-plus', name: '<i data-feather=\'folder-plus\'>Folder plus</i>' },
                    { id: 'folder', name: '<i data-feather=\'folder\'>Folder</i>' },
                    { id: 'framer', name: '<i data-feather=\'framer\'>Framer</i>' },
                    { id: 'frown', name: '<i data-feather=\'frown\'>Frown</i>' },
                    { id: 'gift', name: '<i data-feather=\'gift\'>Gift</i>' },
                    { id: 'git-branch', name: '<i data-feather=\'git-branch\'>Git branch</i>' },
                    { id: 'git-commit', name: '<i data-feather=\'git-commit\'>Git commit</i>' },
                    { id: 'git-merge', name: '<i data-feather=\'git-merge\'>Git merge</i>' },
                    { id: 'git-pull-request', name: '<i data-feather=\'git-pull-request\'>Git pull request</i>' },
                    { id: 'github', name: '<i data-feather=\'github\'>Github</i>' },
                    { id: 'gitlab', name: '<i data-feather=\'gitlab\'>Gitlab</i>' },
                    { id: 'globe', name: '<i data-feather=\'globe\'>Globe</i>' },
                    { id: 'grid', name: '<i data-feather=\'grid\'>Grid</i>' },
                    { id: 'hard-drive', name: '<i data-feather=\'hard-drive\'>Hard drive</i>' },
                    { id: 'hash', name: '<i data-feather=\'hash\'>Hash</i>' },
                    { id: 'headphones', name: '<i data-feather=\'headphones\'>Headphones</i>' },
                    { id: 'heart', name: '<i data-feather=\'heart\'>Heart</i>' },
                    { id: 'help-circle', name: '<i data-feather=\'help-circle\'>Help circle</i>' },
                    { id: 'hexagon', name: '<i data-feather=\'hexagon\'>Hexagon</i>' },
                    { id: 'home', name: '<i data-feather=\'home\'>Home</i>' },
                    { id: 'image', name: '<i data-feather=\'image\'>Image</i>' },
                    { id: 'inbox', name: '<i data-feather=\'inbox\'>Inbox</i>' },
                    { id: 'info', name: '<i data-feather=\'info\'>Info</i>' },
                    { id: 'instagram', name: '<i data-feather=\'instagram\'>Instagram</i>' },
                    { id: 'italic', name: '<i data-feather=\'italic\'>Italic</i>' },
                    { id: 'key', name: '<i data-feather=\'key\'>Key</i>' },
                    { id: 'layers', name: '<i data-feather=\'layers\'>Layers</i>' },
                    { id: 'layout', name: '<i data-feather=\'layout\'>Layout</i>' },
                    { id: 'life-buoy', name: '<i data-feather=\'life-buoy\'>Life buoy</i>' },
                    { id: 'link-2', name: '<i data-feather=\'link-2\'>Link 2</i>' },
                    { id: 'link', name: '<i data-feather=\'link\'>Link</i>' },
                    { id: 'linkedin', name: '<i data-feather=\'linkedin\'>Linkedin</i>' },
                    { id: 'list', name: '<i data-feather=\'list\'>List</i>' },
                    { id: 'loader', name: '<i data-feather=\'loader\'>Loader</i>' },
                    { id: 'lock', name: '<i data-feather=\'lock\'>Lock</i>' },
                    { id: 'log-in', name: '<i data-feather=\'log-in\'>Log in</i>' },
                    { id: 'log-out', name: '<i data-feather=\'log-out\'>Log out</i>' },
                    { id: 'mail', name: '<i data-feather=\'mail\'>Mail</i>' },
                    { id: 'map-pin', name: '<i data-feather=\'map-pin\'>Map pin</i>' },
                    { id: 'map', name: '<i data-feather=\'map\'>Map</i>' },
                    { id: 'maximize-2', name: '<i data-feather=\'maximize-2\'>Maximize 2</i>' },
                    { id: 'maximize', name: '<i data-feather=\'maximize\'>Maximize</i>' },
                    { id: 'meh', name: '<i data-feather=\'meh\'>Meh</i>' },
                    { id: 'menu', name: '<i data-feather=\'menu\'>Menu</i>' },
                    { id: 'message-circle', name: '<i data-feather=\'message-circle\'>Message circle</i>' },
                    { id: 'message-square', name: '<i data-feather=\'message-square\'>Message square</i>' },
                    { id: 'mic-off', name: '<i data-feather=\'mic-off\'>Mic off</i>' },
                    { id: 'mic', name: '<i data-feather=\'mic\'>Mic</i>' },
                    { id: 'minimize-2', name: '<i data-feather=\'minimize-2\'>Minimize 2</i>' },
                    { id: 'minimize', name: '<i data-feather=\'minimize\'>Minimize</i>' },
                    { id: 'minus-circle', name: '<i data-feather=\'minus-circle\'>Minus circle</i>' },
                    { id: 'minus-square', name: '<i data-feather=\'minus-square\'>Minus square</i>' },
                    { id: 'minus', name: '<i data-feather=\'minus\'>Minus</i>' },
                    { id: 'monitor', name: '<i data-feather=\'monitor\'>Monitor</i>' },
                    { id: 'moon', name: '<i data-feather=\'moon\'>Moon</i>' },
                    { id: 'more-horizontal', name: '<i data-feather=\'more-horizontal\'>More horizontal</i>' },
                    { id: 'more-vertical', name: '<i data-feather=\'more-vertical\'>More vertical</i>' },
                    { id: 'mouse-pointer', name: '<i data-feather=\'mouse-pointer\'>Mouse pointer</i>' },
                    { id: 'move', name: '<i data-feather=\'move\'>Move</i>' },
                    { id: 'music', name: '<i data-feather=\'music\'>Music</i>' },
                    { id: 'navigation-2', name: '<i data-feather=\'navigation-2\'>Navigation 2</i>' },
                    { id: 'navigation', name: '<i data-feather=\'navigation\'>Navigation</i>' },
                    { id: 'octagon', name: '<i data-feather=\'octagon\'>Octagon</i>' },
                    { id: 'package', name: '<i data-feather=\'package\'>Package</i>' },
                    { id: 'paperclip', name: '<i data-feather=\'paperclip\'>Paperclip</i>' },
                    { id: 'pause-circle', name: '<i data-feather=\'pause-circle\'>Pause circle</i>' },
                    { id: 'pause', name: '<i data-feather=\'pause\'>Pause</i>' },
                    { id: 'pen-tool', name: '<i data-feather=\'pen-tool\'>Pen tool</i>' },
                    { id: 'percent', name: '<i data-feather=\'percent\'>Percent</i>' },
                    { id: 'phone-call', name: '<i data-feather=\'phone-call\'>Phone call</i>' },
                    { id: 'phone-forwarded', name: '<i data-feather=\'phone-forwarded\'>Phone forwarded</i>' },
                    { id: 'phone-incoming', name: '<i data-feather=\'phone-incoming\'>Phone incoming</i>' },
                    { id: 'phone-missed', name: '<i data-feather=\'phone-missed\'>Phone missed</i>' },
                    { id: 'phone-off', name: '<i data-feather=\'phone-off\'>Phone off</i>' },
                    { id: 'phone-outgoing', name: '<i data-feather=\'phone-outgoing\'>Phone outgoing</i>' },
                    { id: 'phone', name: '<i data-feather=\'phone\'>Phone</i>' },
                    { id: 'pie-chart', name: '<i data-feather=\'pie-chart\'>Pie chart</i>' },
                    { id: 'play-circle', name: '<i data-feather=\'play-circle\'>Play circle</i>' },
                    { id: 'play', name: '<i data-feather=\'play\'>Play</i>' },
                    { id: 'plus-circle', name: '<i data-feather=\'plus-circle\'>Plus circle</i>' },
                    { id: 'plus-square', name: '<i data-feather=\'plus-square\'>Plus square</i>' },
                    { id: 'plus', name: '<i data-feather=\'plus\'>Plus</i>' },
                    { id: 'pocket', name: '<i data-feather=\'pocket\'>Pocket</i>' },
                    { id: 'power', name: '<i data-feather=\'power\'>Power</i>' },
                    { id: 'printer', name: '<i data-feather=\'printer\'>Printer</i>' },
                    { id: 'radio', name: '<i data-feather=\'radio\'>Radio</i>' },
                    { id: 'refresh-ccw', name: '<i data-feather=\'refresh-ccw\'>Refresh ccw</i>' },
                    { id: 'refresh-cw', name: '<i data-feather=\'refresh-cw\'>Refresh cw</i>' },
                    { id: 'repeat', name: '<i data-feather=\'repeat\'>Repeat</i>' },
                    { id: 'rewind', name: '<i data-feather=\'rewind\'>Rewind</i>' },
                    { id: 'rotate-ccw', name: '<i data-feather=\'rotate-ccw\'>Rotate ccw</i>' },
                    { id: 'rotate-cw', name: '<i data-feather=\'rotate-cw\'>Rotate cw</i>' },
                    { id: 'rss', name: '<i data-feather=\'rss\'>Rss</i>' },
                    { id: 'scissors', name: '<i data-feather=\'scissors\'>Scissors</i>' },
                    { id: 'server', name: '<i data-feather=\'server\'>Server</i>' },
                    { id: 'share-2', name: '<i data-feather=\'share-2\'>Share 2</i>' },
                    { id: 'share', name: '<i data-feather=\'share\'>Share</i>' },
                    { id: 'shield-off', name: '<i data-feather=\'shield-off\'>Shield off</i>' },
                    { id: 'shield', name: '<i data-feather=\'shield\'>Shield</i>' },
                    { id: 'shopping-bag', name: '<i data-feather=\'shopping-bag\'>Shopping bag</i>' },
                    { id: 'shopping-cart', name: '<i data-feather=\'shopping-cart\'>Shopping cart</i>' },
                    { id: 'shuffle', name: '<i data-feather=\'shuffle\'>Shuffle</i>' },
                    { id: 'sidebar', name: '<i data-feather=\'sidebar\'>Sidebar</i>' },
                    { id: 'skip-back', name: '<i data-feather=\'skip-back\'>Skip back</i>' },
                    { id: 'skip-forward', name: '<i data-feather=\'skip-forward\'>Skip forward</i>' },
                    { id: 'sliders', name: '<i data-feather=\'sliders\'>Sliders</i>' },
                    { id: 'smartphone', name: '<i data-feather=\'smartphone\'>Smartphone</i>' },
                    { id: 'speaker', name: '<i data-feather=\'speaker\'>Speaker</i>' },
                    { id: 'square', name: '<i data-feather=\'square\'>Square</i>' },
                    { id: 'stop-circle', name: '<i data-feather=\'stop-circle\'>Stop circle</i>' },
                    { id: 'sunrise', name: '<i data-feather=\'sunrise\'>Sunrise</i>' },
                    { id: 'sunset', name: '<i data-feather=\'sunset\'>Sunset</i>' },
                    { id: 'tablet', name: '<i data-feather=\'tablet\'>Tablet</i>' },
                    { id: 'tag', name: '<i data-feather=\'tag\'>Tag</i>' },
                    { id: 'thermometer', name: '<i data-feather=\'thermometer\'>Thermometer</i>' },
                    { id: 'thumbs-down', name: '<i data-feather=\'thumbs-down\'>Thumbs down</i>' },
                    { id: 'thumbs-up', name: '<i data-feather=\'thumbs-up\'>Thumbs up</i>' },
                    { id: 'toggle-left', name: '<i data-feather=\'toggle-left\'>Toggle left</i>' },
                    { id: 'toggle-right', name: '<i data-feather=\'toggle-right\'>Toggle right</i>' },
                    { id: 'tool', name: '<i data-feather=\'tool\'>Tool</i>' },
                    { id: 'trash-2', name: '<i data-feather=\'trash-2\'>Trash 2</i>' },
                    { id: 'trello', name: '<i data-feather=\'trello\'>Trello</i>' },
                    { id: 'trending-down', name: '<i data-feather=\'trending-down\'>Trending down</i>' },
                    { id: 'trending-up', name: '<i data-feather=\'trending-up\'>Trending up</i>' },
                    { id: 'truck', name: '<i data-feather=\'truck\'>Truck</i>' },
                    { id: 'youtube', name: '<i data-feather=\'youtube\'>Youtube</i>' },
                    { id: 'zap-off', name: '<i data-feather=\'zap-off\'>Zap off</i>' },
                    { id: 'zoom-in', name: '<i data-feather=\'zoom-in\'>Zoom in</i>' },
                    { id: 'zoom-out', name: '<i data-feather=\'zoom-out\'>Zoom out</i>' }
                ]"
            />
            <app-form-group
                page="page"
                type="select"
                v-model="formData.type"
                list-value-field="name"
                :required="true"
                :label="$t('type')"
                :list="[
                    {id: 'text', name: $t('text')},
                    {id: 'textarea', name: $t('textarea')},
                    {id: 'select', name: $t('select')},
                    {id: 'file', name: $t('file')},
                ]"
            />
            <app-form-group-selectable
                page="page"
                type="select"
                :label="$t('entity_type')"
                v-model="formData.entity_type"
                list-value-field="name"
                :chooseLabel="$t('entity_type')"
                :error-message="$errorMessage(errors, 'entity_type')"
                :fetch-url="`${TENANT_BASE_URL}api/attribute/type`"
                :required="true"
            />
            <app-form-group
                v-if="formData.type === 'select'"
                labelAlignment="top"
                page="page"
                type="textarea"
                row="5"
                :label="$t('options')"
                :placeholder="$placeholder('options', '')"
                v-model="formData.options"
                :error-message="$errorMessage(errors, 'options')"
            />
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";
import {mapState} from "vuex";

export default {
    name  : "HotelAttributeCreateModal",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            TENANT_BASE_URL,
            locate  : 'ja',
            formData: {
                label      : {},
                name       : '',
                icon       : '',
                order      : 0,
                type       : 'text',
                entity_type: '',
                is_active  : 1,
                options    : '',
            },
        }
    },
    computed: {
        ...mapState({
            languages: state => state.support.languages
        }),
    },
    methods : {
        submitData() {
            let url      = this.$refs.form.dataset["url"];
            let formData = formDataAssigner(new FormData, this.formData);

            if (this.formData.label) {
                formData.set('label', JSON.stringify(this.formData.label))
            }

            if (this.selectedUrl) {
                // for file update need to send by post.
                formData.append('_method', 'PATCH');
            }

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#attribute-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'attribute-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData  = {
                label      : this.isEmptyArray(response.data.label),
                name       : response.data.name,
                icon       : response.data.icon,
                order      : response.data.order,
                type       : response.data.type,
                entity_type: response.data.entity_type,
                is_active  : response.data.is_active,
                options    : response.data.options ? response.data.options.join("\n") : '',
            };
        },
        isEmptyArray(val) {
            if (!val) {
                return {}
            }
            return Array.isArray(val) && val.length === 0 ? {} : val;
        }
    },
}
</script>

